import DisplayToken from './displayToken';
const ServerlessTokens = () => {
  return (
    <>
      <div className="container mt-8">
        <div className="flex gap-2">
          <p className="text-lg font-semibold">Tokens</p>
        </div>
        <div className="mt-4 grid gap-8">
          <DisplayToken />
        </div>
      </div>
    </>
  );
};

export default ServerlessTokens;
